'use strict';

var billingHelper = require('int_razorpay/razorpayButtons/billingHelper');
var toastMessageHelper = require('../utils/toastMessageHelper');
/**
 * Exports a module with two functions: razorpay and ondismiss.
 * @module paymentHelper
 * Requires the billingHelper module.
 * @requires ./billingHelper
 * Exports a function that initializes the Razorpay checkout process.
 * @function razorpay
 * @memberof module:paymentHelper
 */
module.exports = {
    razorpay: function () {
        $('body').on('checkout:razorpaycheckout', function (e, isPayment) {
            var callbackurl = $('.handlecallback').attr('data-url');
            var razorpayurl = $('.razorpayservicecall').attr('data-url');
            var razorpayredirecturl = $('.redirectCheckout').attr('data-url');
            var razorpaycancelurl = $('.cancelurl').attr('data-url');
            $.spinner().start();
            $.ajax({
                url: razorpayurl,
                method: 'POST',
                data: {
                    gstinNumber: $('#gstinNumber').val() || '',
                    isPayment: isPayment || false
                },
                success: function (data) {
                    $.spinner().stop();
                    if (data && data.error) {
                        if (data.missing && data.missing.length) {
                            $('body').trigger('checkout:validationError', [data]);
                        }

                        if (data && data.error && (data.errorCode || data.cartError)) {
                            toastMessageHelper.showNotification(data.errorMessage);
                        }

                        return;
                    }
                    if (data) {
                        try {
                            if (data.razorPayOptionObject) {
                                var rpObj = JSON.parse(data.razorPayOptionObject);
                                if (rpObj && rpObj.error) {
                                    toastMessageHelper.showNotification(rpObj.errorMessage);
                                    return;
                                }
                            }
                        } catch (error) {
                            // ignore
                        }
                        var options = billingHelper.createRazorPayOptions(callbackurl, razorpaycancelurl, data, razorpayredirecturl);
                        // eslint-disable-next-line no-undef
                        var rzp1 = new Razorpay(options);
                        rzp1.open();
                        e.preventDefault();
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    ondismiss: function () {
        var backFromPG = $('.backFromPG').val() === 'true';
        if (backFromPG) {
            $('.payment-cancel-message').removeClass('d-none');
            $('.razorpaycheckout').attr('disabled', true);
        }
    }
};
